<div class="not-found">
  <div class="not-found__content">
    <div class="not-found__graphic" aria-hidden="true">
      <svg class="orbit" viewBox="0 0 400 400">
        <defs>
          <linearGradient id="nf-ring" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#0047AB" />
            <stop offset="100%" stop-color="#f8a03b" />
          </linearGradient>
        </defs>
        <circle cx="200" cy="200" r="185" fill="none" stroke="url(#nf-ring)" stroke-width="2" stroke-dasharray="6 10" opacity="0.6" />
        <circle cx="200" cy="200" r="145" fill="none" stroke="#0047AB" stroke-width="1" opacity="0.25" />
        <circle class="orbit__dot" cx="200" cy="15" r="9" fill="#f8a03b" />
        <circle class="orbit__dot orbit__dot--small" cx="55" cy="200" r="6" fill="#0047AB" />
      </svg>

      <div class="digits">
        <span>4</span>
        <div class="logo-badge">
          <img src="assets/images/Rondeivu_icon_white.png" alt="Rondeivu" />
        </div>
        <span>4</span>
      </div>
    </div>

    <h2 class="not-found__title">Page not found</h2>
    <p class="not-found__text">
      Sorry, the page you're looking for doesn't exist or has been moved.
      Please check the URL or head back to the login page.
    </p>

    <div class="not-found__actions">
      <button mat-raised-button color="primary" routerLink="/auth/login" [queryParams]="{ action: 'noredirect' }">Go to Login</button>
      <button mat-stroked-button color="primary" (click)="goBack()">Go Back</button>
    </div>
  </div>
</div>
